import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmAlignChilds extends wmBase {
    constructor(options: widgetOption<string>[]) {
        super();
        this.options = options;
    }

    build() {
        return `
            <div class="wm_alignChilds">
               ${this.viewUrl}
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_alignChilds");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (e) => {
        this.applyValue(this.options, {});
    };

    name = "wm_alignChilds";
    options: widgetOption<string>[] = [];
    viewUrl = `
            <svg width="23" height="23" viewBox="0 0 121 121" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="53" y1="5" x2="53" y2="116" stroke="#545454" stroke-width="10" stroke-linecap="round"/>
            <line x1="74" y1="26" x2="116" y2="26" stroke="#545454" stroke-width="10" stroke-linecap="round"/>
            <line x1="74" y1="91" x2="116" y2="91" stroke="#545454" stroke-width="10" stroke-linecap="round"/>
            <line x1="74" y1="58" x2="103" y2="58" stroke="#545454" stroke-width="10" stroke-linecap="round"/>
            <path d="M2.98281 57.7579C1.60213 57.7674 0.490567 58.8943 0.500059 60.275C0.509551 61.6557 1.63651 62.7672 3.01719 62.7578L2.98281 57.7579ZM42.2809 61.7556C43.2504 60.7726 43.2395 59.1897 42.2565 58.2201L26.2376 42.42C25.2546 41.4504 23.6718 41.4613 22.7022 42.4443C21.7326 43.4273 21.7435 45.0102 22.7265 45.9797L36.9655 60.0243L22.9209 74.2633C21.9514 75.2463 21.9623 76.8292 22.9453 77.7988C23.9283 78.7684 25.5111 78.7575 26.4807 77.7745L42.2809 61.7556ZM3.01719 62.7578L40.5182 62.4999L40.4838 57.5001L2.98281 57.7579L3.01719 62.7578Z" fill="#545454"/>
            </svg>
        `;
}
